//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      messages: 'protect/messages',
      timeout: 'protect/messageTimeout',
      isPastDue: 'protect/isPastDue'
    })
  },
  mounted () {
    this.startPolling()
  },
  beforeDestroy () {
    this.stopPolling()
  },
  methods: {
    startPolling () {
      this.pollingInterval = setInterval(this.poll, 500)
    },
    stopPolling () {
      clearInterval(this.pollingInterval)
    },
    poll () {
      // Check if any messages are older than the limit
      if (this.messages.filter(message => message.timestamp < (new Date()).valueOf() - this.timeout).length) {
        this.$store.commit('protect/CLEAN_MESSAGES')
      }
    }
  }
}
